<template>
  <!-- 审核确认弹窗 -->
        <!-- :is-valid="validateVerify" -->

    <vs-prompt
        classContent="popup-example"
        title="审核确认"
        acceptText="确认审核"
        cancelText="取消"
        :active="visible"
        @cancel="handleClose"
        @accept="OnconfirmOrder">
            <div class="flex alignCenter deliver-dialog">
            <div class="flex alignCenter">
                <div>选择仓库</div>
                <template>
                    <v-select
                        v-model="deliverParam.wsId"
                        :options="distOptions"
                        :reduce="opt => opt.id"
                        placeholder="请选择仓库"
                        @change="getLocOptions"
                        @input="getLocOptions"
                        class="marLeft16"
                    >
                        <div slot="no-options">暂无选项</div>
                    </v-select>
                </template>
            </div>
            
            <div class="flex alignCenter marLeft16">
                <div>选择仓位</div>
                <template>
                    <v-select v-model="deliverParam.locId" 
                            :options="locOptions" 
                            :reduce="opt => opt.id" 
                            placeholder="请选择仓位"
                            class="marLeft16">
                        <div slot="no-options">暂无选项</div>
                    </v-select>
                </template>
            </div>
        </div>
            <el-table
            :data="stockData"
            class="marTop20"
            :span-method="arraySpanMethod"
            style="width: 100%">
            <el-table-column
                prop="skuName"
                label="商品名称"
                width="180">
            </el-table-column>
            <el-table-column
                prop="orderAmount"
                label="下单数量">
            </el-table-column>
            <el-table-column
                prop="sendSkuName"
                label="发货商品">
            </el-table-column>
            <el-table-column
                prop="sendAmount"
                label="发货数量">
            </el-table-column>
            <el-table-column
                prop="actualAmount"
                label="当前库存">
            </el-table-column>
                <el-table-column
                prop="actualAmountEnd"
                label="发货后库存">
            </el-table-column>
        </el-table>
    </vs-prompt>
</template>

<script>
  export default {
    props: {
        visible: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        handleClose() {
            this.$emit("update:visible", false);

        }
    },
  }
</script>

<style lang="scss" scoped>

</style>